import { produce } from 'immer';

import type {
	SignupCompany,
	SignupProps,
	SignupState,
	SignupUser,
} from '@/types';

const initialState: SignupProps = {
	user: {
		uuid: '',
		firstName: '',
		lastName: '',
		mobileNumberPrefix: '+63',
		mobileNumber: '',
		email: '',
		username: '',
		password: '',
		oauthProvider: null,
		oauthProviderKey: null,
	},
	company: {
		uuid: '',
		name: '',
		address: '',
		workEmail: '',
		companySize: '',
		mobileNumber: '',
		natureOfBusiness: '',
		natureOfBusinessOther: '',
	},
};

export const createSignupStore = (
	set: (
		state:
			| Partial<SignupState>
			| ((state: SignupState) => Partial<SignupState>),
	) => void,
) => ({
	...initialState,
	isHydrated: false,
	resetState: () => set(initialState),
	setIsHydrated: (isHydrated: boolean) => set({ isHydrated }),
	setUser: (user: SignupUser) =>
		set(
			produce((state: SignupState) => {
				state.user = user;
			}),
		),
	setUsernameAndPassword: (user: SignupUser) =>
		set(
			produce((state: SignupState) => {
				// Preserve existing user data (including OAuth fields) and only update username/password
				state.user = {
					...state.user,
					username: user.username,
					password: user.password,
				};
			}),
		),
	setCompany: (company: SignupCompany) =>
		set(
			produce((state: SignupState) => {
				state.company = company;
			}),
		),
});
